import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CKButton } from 'clearkit';

import styles from './ConfirmDeleteModal.style';

const AssociatedItemsWarning = ({
  type,
  childType,
  associatedItemNames,
  classes,
}) => (
  <>
    <p className={classes.warningMessage}>
      This will also delete any {childType} associated with this {type}.
    </p>

    <div>
      <p style={{ fontWeight: 600 }}>
        The following {childType} will also be deleted:
      </p>

      {associatedItemNames.map((item, index) => (
        <div className={classes.itemToBeDeleted} key={index}>
          {item}
        </div>
      ))}
    </div>
  </>
);

AssociatedItemsWarning.propTypes = {
  type: PropTypes.string,
  currentId: PropTypes.string,
  childType: PropTypes.string,
  classes: PropTypes.object.isRequired,
  associatedItemNames: PropTypes.array,
};

class ConfirmDeleteModal extends React.Component {
  childType = () => {
    const { type } = this.props;

    switch (type) {
      case 'segment':
        return 'destinations';
      case 'collection':
        return 'audiences and destinations';
      default:
        break;
    }
  };

  onClose = (shouldDelete) => {
    const { deleteItem, closeModal, item, type } = this.props;
    closeModal();

    if (shouldDelete) deleteItem(type, item);
  };

  render() {
    const {
      open,
      type,
      classes,
      item,
      associatedItemNames,
      canDelete,
      subTitle,
    } = this.props;

    return (
      <Dialog maxWidth="lg" onExited={() => this.onClose(false)} open={open}>
        <DialogTitle disableTypography>
          {canDelete
            ? `Are you sure you want to delete this ${type}?`
            : `You cannot delete your last ${type}`}
        </DialogTitle>

        <DialogContent>
          {subTitle && subTitle}

          {associatedItemNames.length > 0 && canDelete && (
            <AssociatedItemsWarning
              associatedItemNames={associatedItemNames}
              childType={this.childType()}
              classes={classes}
              item={item}
              type={type}
            />
          )}
        </DialogContent>
        <DialogActions className={classes.actions}>
          <CKButton onClick={() => this.onClose(false)} variant="secondary">
            Cancel
          </CKButton>

          {canDelete && (
            <CKButton
              className={classes.deleteButton}
              onClick={() => this.onClose(true)}
              variant="bold"
              variantColor="red"
            >
              Delete {type}
            </CKButton>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

ConfirmDeleteModal.defaultProps = {
  associatedItemNames: [],
  item: null,
};

ConfirmDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  item: PropTypes.object,
  subTitle: PropTypes.string,
  associatedItemNames: PropTypes.array,
  canDelete: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([
    'segment',
    'collection',
    'audience',
    'destination',
    null,
  ]),
};

export default withStyles(styles)(ConfirmDeleteModal);
